(function () {
  // Prevent double init (Shopify can re-render sections)
  if (window.__VS_CONFIG_RUNNING__) return;
  window.__VS_CONFIG_RUNNING__ = true;

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    const $ = (s) => document.querySelector(s);

    const els = {
      vin: $("#vsVin"),
      manufacturer: $("#vsManufacturer"),
      model: $("#vsModel"),
      typeApproval: $("#vsTypeApproval"),
      colour: $("#vsColour"),
      setPill: $("#vsSetPill"),
      add: $("#vsAddToCart"),
      stageWrap: $("#vsStage"),
      tabs: document.querySelectorAll(".vinshield-tabs .tab"),
    };

    // Hard stop if DOM doesn't match
    if (!els.stageWrap || !els.vin || !els.add) {
      console.error("VS: Missing required elements. Check IDs in liquid.", els);
      return;
    }
    if (!window.Konva) {
      console.error("VS: Konva not loaded.");
      return;
    }

    const state = {
      set: "complete",
      vin: els.vin.value || "WF0YXXTTGYCT512345",
      manufacturer: els.manufacturer?.value || "FORD-WERKE GMBH",
      model: els.model?.value || "TRANSIT / CUSTOM",
      typeApproval: els.typeApproval?.value || "E1*2007/46*1005",
      colour: els.colour?.value || "PN4 • WHITE",
    };

    function normalizeVIN(v) {
      return (v || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 17);
    }
    function upcase(v) {
      return (v || "").toUpperCase();
    }
    function labelSet(set) {
      if (set === "door") return "DOOR / B-PILLAR";
      if (set === "windscreen") return "WINDSCREEN";
      return "COMPLETE SET";
    }

    // ---------- Konva render ----------
    const pad = 26;

    function buildStage() {
      // Clear container in case Shopify re-rendered DOM
      els.stageWrap.innerHTML = "";

      const w = els.stageWrap.clientWidth || 600;
      const h = els.stageWrap.clientHeight || 420;

      const stage = new Konva.Stage({
        container: "vsStage",
        width: w,
        height: h,
      });

      const layer = new Konva.Layer();
      stage.add(layer);

      const plate = new Konva.Rect({
        x: pad,
        y: 70,
        width: w - pad * 2,
        height: h - 140,
        cornerRadius: 18,
        fill: "rgba(0,0,0,0.25)",
        stroke: "rgba(120,170,255,0.35)",
        strokeWidth: 2,
      });

      const header = new Konva.Text({
        x: pad + 22,
        y: 92,
        text: "SASIS • " + labelSet(state.set),
        fontSize: 12,
        fontStyle: "bold",
        fill: "rgba(200,225,255,0.85)",
        letterSpacing: 2,
      });

      const vinText = new Konva.Text({
        x: pad + 22,
        y: 122,
        text: normalizeVIN(state.vin) || "—",
        fontSize: 30,
        fontStyle: "bold",
        fill: "rgba(245,250,255,0.95)",
        letterSpacing: 2,
      });
      function fitVinToWidth() {
  const maxWidth = plate.width() - 44; // marge interne (22px de chaque côté)
  // reset de départ
  vinText.fontSize(30);
  vinText.letterSpacing(2);

  // Si écran très petit, on réduit encore l'espacement
  if (stage.width() < 420) vinText.letterSpacing(1);

  // Réduit la taille tant que ça dépasse
  while (vinText.width() > maxWidth && vinText.fontSize() > 16) {
    vinText.fontSize(vinText.fontSize() - 1);
  }
}


      const line = new Konva.Rect({
        x: pad + 18,
        y: 170,
        width: w - pad * 2 - 36,
        height: 2,
        fill: "rgba(120,170,255,0.25)",
      });

      const manu = new Konva.Text({
        x: pad + 22,
        y: 188,
        text: upcase(state.manufacturer) || "—",
        fontSize: 18,
        fontStyle: "bold",
        fill: "rgba(235,245,255,0.92)",
      });

      const model = new Konva.Text({
        x: pad + 22,
        y: 216,
        text: upcase(state.model) || "—",
        fontSize: 14,
        fontStyle: "bold",
        fill: "rgba(220,235,255,0.85)",
      });

      const type = new Konva.Text({
        x: pad + 22,
        y: 240,
        text: upcase(state.typeApproval) || "—",
        fontSize: 13,
        fontStyle: "bold",
        fill: "rgba(210,230,255,0.8)",
        letterSpacing: 1,
      });

      const colour = new Konva.Text({
        x: pad + 22,
        y: h - 140,
        text: "COLOUR " + (upcase(state.colour) || "—"),
        fontSize: 13,
        fontStyle: "bold",
        fill: "rgba(210,230,255,0.8)",
        letterSpacing: 1,
      });

      const noise = new Konva.Rect({
        x: pad,
        y: 70,
        width: w - pad * 2,
        height: h - 140,
        cornerRadius: 18,
        fill: "rgba(255,255,255,0.03)",
      });

      layer.add(plate, header, vinText, line, manu, model, type, colour, noise);
      layer.draw();

      function rerender() {
        header.text("SASIS • " + labelSet(state.set));
        vinText.text(normalizeVIN(state.vin) || "—");
        fitVinToWidth();
        fitVinToWidth();
        manu.text(upcase(state.manufacturer) || "—");
        model.text(upcase(state.model) || "—");
        type.text(upcase(state.typeApproval) || "—");
        colour.text("COLOUR " + (upcase(state.colour) || "—"));
        layer.draw();
      }

      function resize() {
        const nw = els.stageWrap.clientWidth || w;
        const nh = els.stageWrap.clientHeight || h;
        stage.size({ width: nw, height: nh });

        plate.width(nw - pad * 2);
        plate.height(nh - 140);
        noise.width(nw - pad * 2);
        noise.height(nh - 140);
        line.width(nw - pad * 2 - 36);
        colour.y(nh - 140);

        rerender();
      }

      return { rerender, resize };
    }

    const preview = buildStage();

    function update() {
      if (els.setPill) {
        els.setPill.textContent =
          "SET • " +
          (state.set === "complete"
            ? "Complete"
            : state.set === "door"
            ? "Door / B-Pillar"
            : "Windscreen");
      }
      preview.rerender();
    }

    // Inputs
    els.vin.addEventListener("input", (e) => {
      state.vin = normalizeVIN(e.target.value);
      e.target.value = state.vin;
      update();
    });
    els.manufacturer?.addEventListener("input", (e) => {
      state.manufacturer = e.target.value;
      update();
    });
    els.model?.addEventListener("input", (e) => {
      state.model = e.target.value;
      update();
    });
    els.typeApproval?.addEventListener("input", (e) => {
      state.typeApproval = e.target.value;
      update();
    });
    els.colour?.addEventListener("input", (e) => {
      state.colour = e.target.value;
      update();
    });

    // Tabs
    els.tabs.forEach((btn) => {
      btn.addEventListener("click", () => {
        els.tabs.forEach((b) => b.classList.remove("is-active"));
        btn.classList.add("is-active");
        state.set = btn.dataset.set;
        update();
      });
    });

    // Resize
    window.addEventListener("resize", () => preview.resize());

    // Add to cart
    async function getVariantId() {
      const handle = window.VS_PRODUCT?.handle;
      if (!handle) throw new Error("Missing product handle");
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error("Cannot load product JSON");
      const product = await res.json();
      const v = product.variants.find((x) => x.available) || product.variants[0];
      const fallback = Number(window.VS_PRODUCT?.variantFallback || 0);
      return fallback > 0 ? fallback : v.id;
    }

    async function addToCart() {
      els.add.disabled = true;
      const old = els.add.textContent;
      els.add.textContent = "Adding…";
      try {
        const variantId = await getVariantId();
        const payload = {
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                Set: labelSet(state.set),
                VIN: normalizeVIN(state.vin),
                Manufacturer: upcase(state.manufacturer),
                Model: upcase(state.model),
                "Type approval": upcase(state.typeApproval),
                Colour: upcase(state.colour),
              },
            },
          ],
        };
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload),
        });
        if (!res.ok) throw new Error(await res.text());
        window.location.href = "/cart";
      } catch (err) {
        console.error("VS addToCart error:", err);
        alert("Impossible d'ajouter au panier (handle/variant?).");
      } finally {
        els.add.disabled = false;
        els.add.textContent = old;
      }
    }

els.add.addEventListener("click", (e) => {
  e.preventDefault();
  window.location.href = "/collections";
});

    // First paint
    update();
    console.log("VS: configurator ready");
  });
})();
